module.exports = __webpack_public_path__ + "static/img/jhg_detail2.505564a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jhg_detail2.png
// module id = mBIi
// module chunks = 0